import { ReactComponent as Bussines } from '../../assets/icons/UI/business.svg';
import { ReactComponent as Chat } from '../../assets/icons/UI/chat.svg';
import { ReactComponent as CheckCircle } from '../../assets/icons/UI/check_circle.svg';
import { ReactComponent as Distance } from '../../assets/icons/UI/distance.svg';
import { ReactComponent as Download } from '../../assets/icons/UI/download.svg';
import { ReactComponent as FileSave } from '../../assets/icons/UI/file_save.svg';
import { ReactComponent as Home } from '../../assets/icons/UI/home.svg';
import { ReactComponent as MoreVert } from '../../assets/icons/UI/more_vert.svg';
import { ReactComponent as Wsp } from '../../assets/icons/UI/wsp.svg';
import {ReactComponent as Mail} from '../../assets/icons/UI/mail.svg';
import { ReactComponent as Clinical } from '../../assets/icons/UI/clinical_notes.svg';
import { ReactComponent as Cancel } from '../../assets/icons/UI/cancel.svg';
import { ReactComponent as After } from '../../assets/icons/Content/after.svg';
import { ReactComponent as Css } from '../../assets/icons/Content/css.svg';
import { ReactComponent as Figma } from '../../assets/icons/Content/figma.svg';
import { ReactComponent as Hotjar } from '../../assets/icons/Content/hotjar.svg';
import { ReactComponent as Html } from '../../assets/icons/Content/html.svg';
import { ReactComponent as Illustrator } from '../../assets/icons/Content/illustrator.svg';
import { ReactComponent as Indesign } from '../../assets/icons/Content/indesign.svg';
import { ReactComponent as Javascript } from '../../assets/icons/Content/javascript.svg';
import { ReactComponent as Jira } from '../../assets/icons/Content/jira.svg';
import { ReactComponent as Jquery } from '../../assets/icons/Content/jquery.svg';
import { ReactComponent as Linkedin } from '../../assets/icons/Content/linkedin.svg';
import { ReactComponent as Maze } from '../../assets/icons/Content/maze.svg';
import { ReactComponent as Miro } from '../../assets/icons/Content/miro.svg';
import { ReactComponent as Photoshop } from '../../assets/icons/Content/phoshop.svg';
import { ReactComponent as Premier } from '../../assets/icons/Content/premier.svg';
import { ReactComponent as React } from '../../assets/icons/Content/react.svg';
import { ReactComponent as Scrum } from '../../assets/icons/Content/scrum.svg';
import { ReactComponent as Sketch } from '../../assets/icons/Content/sketch.svg';



const ICONS = {
  business: Bussines,
  chat: Chat,
  check_circle: CheckCircle,
  distance: Distance,
  download: Download,
  file_save: FileSave,
  home: Home,
  more_vert: MoreVert,
  wsp: Wsp,
  clinical:Clinical,
  cancel: Cancel,
  after: After,
  css: Css,
  mail: Mail,
  figma: Figma,
  hotjar: Hotjar,
  html: Html,
  illustrator: Illustrator,
  indesign: Indesign,
  javascript: Javascript,
  jira: Jira,
  jquery: Jquery,
  linkedin: Linkedin,
  maze: Maze,
  miro: Miro,
  photoshop: Photoshop,
  premier: Premier,
  react: React,
  scrum: Scrum,
  sketch: Sketch,
};

const Icon = ({ source, color, ...rest }) => {
  const Component = ICONS[source];
  if (!Component) return null;

  return <Component style={{color}} {...rest} />;
};

export default Icon;